import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import * as fromActions from "./service-change-request.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-change-request.graphql";


@Injectable()
export class ServiceChangeRequestEffects {


  createServiceChangeRequests$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceChangeRequests),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_CHANGE_REQUEST,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceChangeRequest({ serviceChangeRequest: result?.data }));
              await this.notificationService.successMessage('Requested Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceChangeRequests$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceChangeRequests),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_CHANGE_REQUEST,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service change requests'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceChangeRequests({ serviceChangeRequests: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  getPopsmServiceChangeRequests$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getPopsmServiceChangeRequests),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_POPSM_SERVICE_CHANGE_REQUESTS,
        fetchPolicy: 'network-only',
        variables: {
          filtering: {
            received: false
          }
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service change requests'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceChangeRequests({ serviceChangeRequests: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  reviewServiceChangesRequestMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.reviewServiceChangesRequestMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.reviewServiceChangesRequestMutation,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {
          if(data){
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceChangeRequest({ serviceChangeRequest: result?.data }));
              await this.notificationService.successMessage('Requested Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      )
    })
  ), {dispatch: false})

  popsmServiceChangeRequestApproval$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.popsmServiceChangeRequestApproval),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.POPSM_SERVICE_CHANGES_APPROVAL,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceChangeRequest({ id: action.id }));
              await this.notificationService.successMessage(`${ action.input.serviceChangeApprovalDecision === 'APPROVE' ? 'Approved' : 'Rejected'} Successfully`);
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
